/**
 * KPI Skeleton Loading Component
 */

import React from 'react';
import { cn } from '@/lib/utils';

interface KpiSkeletonProps {
  className?: string;
}

export const KpiSkeleton: React.FC<KpiSkeletonProps> = ({ className }) => {
  return (
    <div className={cn(
      "bg-white/80 dark:bg-gray-800/80 backdrop-blur-md rounded-lg p-6 shadow-lg",
      "border border-gray-200 dark:border-gray-700",
      className
    )}>
      {/* Header skeleton */}
      <div className="mb-4">
        <div className="h-6 bg-gray-200 dark:bg-gray-700 rounded animate-pulse w-3/4"></div>
      </div>
      
      {/* KPI items skeleton */}
      <div className="space-y-3">
        {[1, 2, 3, 4].map((index) => (
          <div key={index} className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              {/* Icon skeleton */}
              <div className="w-8 h-8 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></div>
              {/* Label skeleton */}
              <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded animate-pulse w-28"></div>
            </div>
            {/* Value skeleton */}
            <div className="h-5 bg-gray-200 dark:bg-gray-700 rounded animate-pulse w-16"></div>
          </div>
        ))}
      </div>
    </div>
  );
};